import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = ["innerHTML"]

import { computed } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeletedSuccessful',
  setup(__props) {

const { t } = useI18n();

const encodeHTML = (text: string) => {
  return text
    .replace(/è/g, '&egrave;');
};

const bookingDeleteSuccessNotificationMessage = computed(() => {
  return encodeHTML(t("messages.bookingDeleteSuccessNotification"));
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", { innerHTML: bookingDeleteSuccessNotificationMessage.value }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})